import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import FallbackComponent from "./FallbackComponent"
import { useSelector } from 'react-redux';
import adminUserConfig from '../layouts/dashboard/nav/adminUserConfig';
import Page404 from "../pages/Page404";

// admin pages
const ManageUsersPage = lazy(() => import("../pages/admin/ManageUsersPage"));
const ManageCommonItemsPage = lazy(() => import("../pages/admin/ManageCommonItemsPage"))
const ManageCountries = lazy(() => import("../pages/admin/ManageCountries"))
const ManageAllTransactions = lazy(() => import("../pages/admin/ManageAllTransactions"))
const ManageAllReferrals = lazy(() => import("../pages/admin/ManageAllReferrals"))
const ManageAllDisputes = lazy(() => import("../pages/admin/ManageAllDisputes"))
const ManageAllAdminUsers = lazy(() => import("../pages/admin/ManageAllAdminUsers"))
const ManageAllTasks = lazy(() => import("../pages/admin/ManageAllTasks"))
const ManageUTMs = lazy(() => import("../pages/admin/ManageUTMs"))
const ManageAcademicTests = lazy(() => import("../pages/admin/ManageAcademicTests"))
const ManageAcademicTestSets = lazy(() => import("../pages/admin/ManageAcademicTestSets"))
const ManagePrivacyPolicy = lazy(() => import("../pages/admin/ManagePrivacyPolicy"))
const ManageAboutUs = lazy(() => import("../pages/admin/ManageAboutUs"))
const ManageTerms = lazy(() => import("../pages/admin/ManageTerms"))
const ManageExpertTransactions = lazy(() => import("../pages/admin/ManageExpertTransactions"))
const ManageBlogs = lazy(() => import("../pages/admin/ManageBlogs"))
const AddBlog = lazy(() => import("../pages/admin/AddBlog"))
const EditBlog = lazy(() => import("../pages/admin/EditBlog"))

const SuperAdminPath = ({ userRole }) => {
    const userAccesses = useSelector((state) => state.userState?.userData?.access)
    const selectedRoleURL = userRole === "SuperAdmin" ?
        "super-admin" : "admin-dashboard"
    const displayList = adminUserConfig(selectedRoleURL,
        userRole === "SuperAdmin" ? "0" : userAccesses, "url_structure")

    return (
        <Routes>
            <Route path="*" element={<Navigate replace to={`/${selectedRoleURL}/not-found`} />} />
            <Route
                path="not-found"
                element={<Page404 />}
            />
            <Route
                path="users"
                element={
                    <GetElement id={"1"} displayList={displayList}>
                        <ManageUsersPage
                            title={"Manage Users"}
                            heading={"Manage Users"}
                            name={"User"}
                        />
                    </GetElement>}
            />
            <Route
                path="manage-admin-users"
                element={
                    <GetElement id={"22"} displayList={displayList}>
                        <ManageAllAdminUsers />
                    </GetElement>}
            />

            <Route
                path="all-transactions"
                element={
                    <GetElement id={"2"} displayList={displayList}>
                        <ManageAllTransactions
                            title={"All Transactions"}
                            heading={"All Transactions"}
                            name={"All Transactions"}
                        />
                    </GetElement>
                }
            />

            <Route
                path="payment-requests"
                element={
                    <GetElement id={"3"} displayList={displayList}>
                        <ManageExpertTransactions
                            title={"Payment Requests"}
                            heading={"Payment Requests"}
                            name={"payment-requests"}
                        />
                    </GetElement>
                }
            />

            <Route
                path="dispute-resolution"
                element={
                    <GetElement id={"4"} displayList={displayList}>
                        <ManageAllDisputes
                            title={"Dispute Resolution"}
                            heading={"Disputes Resolution"}
                            name={"dispute-resolution"}
                        />
                    </GetElement>
                }
            />

            <Route
                path="all-referrals"
                element={<GetElement id={"5"} displayList={displayList}>
                    <ManageAllReferrals
                        title={"All Referrals"}
                        heading={"All Transactions"}
                        name={"All Referrals"}
                    />
                </GetElement>
                }
            />

            <Route
                path="all-tasks"
                element={
                    <GetElement id={"6"} displayList={displayList}>
                        <ManageAllTasks
                            title={"All Tasks"}
                            heading={"Task Management"}
                            name={"all-tasks"}
                        />
                    </GetElement>
                }
            />
            <Route
                path="all-utm"
                element={
                    <GetElement id={"7"} displayList={displayList}>
                        <ManageUTMs
                            title={"All UTMs"}
                            heading={"All UTMs"}
                            name={"all-utm"}
                        />
                    </GetElement>
                }
            />
            <Route
                path="cancellationReason"
                element={
                    <GetElement id={"8"} displayList={displayList}>
                        <ManageCommonItemsPage
                            API_URL={"CANCEL_REASON_API_URL"}
                            title={"Manage Cancellation Reason"}
                            heading={"Manage Cancellation Reason"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="blogs"
                element={
                    <GetElement id={"9"} displayList={displayList}>
                        <ManageBlogs
                            title={"Manage Blogs"}
                            heading={"Manage Blogs"}
                            name={"Blogs"}
                        />
                    </GetElement>
                }
            />

            <Route
                path="add-blog"
                element={
                    <GetElement id={"9"} displayList={displayList}>
                        <AddBlog
                            title={"Add Blogs"}
                            heading={"Add Blogs"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="edit-blog"
                element={
                    <GetElement id={"9"} displayList={displayList}>
                        <EditBlog
                            title={"Edit Blog"}
                            heading={"Edit Blog"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="services"
                element={
                    <GetElement id={"10"} displayList={displayList}>
                        <ManageCommonItemsPage
                            API_URL={"SERVICE_API_URL"}
                            title={"Manage Services"}
                            heading={"Manage Services"}
                            name={"Service"}
                        />
                    </GetElement>
                }
            />

            <Route
                path="skills"
                element={
                    <GetElement id={"11"} displayList={displayList}>
                        <ManageCommonItemsPage
                            API_URL={"SKILLS_API_URL"}
                            title={"Manage Skills"}
                            heading={"Manage Skills"}
                            name={"Skill"}
                        />
                    </GetElement>
                }
            />

            <Route
                path="highest-degree"
                element={
                    <GetElement id={"12"} displayList={displayList}>
                        <ManageCommonItemsPage
                            API_URL={"HIGHEST_DEGREE_API_URL"}
                            title={"Manage Highest Degree"}
                            heading={"Manage Highest Degree"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="software-required"
                element={
                    <GetElement id={"13"} displayList={displayList}>
                        <ManageCommonItemsPage
                            API_URL={"SOFTWARE_REQUIRED_API_URL"}
                            title={"Manage Software Required"}
                            heading={"Manage Software Required"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="specialization"
                element={
                    <GetElement id={"14"} displayList={displayList}>
                        <ManageCommonItemsPage
                            API_URL={"SPECIALIZATION_API_URL"}
                            title={"Manage Specialization"}
                            heading={"Manage Specialization"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="subjects"
                element={
                    <GetElement id={"15"} displayList={displayList}>
                        <ManageCommonItemsPage
                            API_URL={"SUBJECTS_API_URL"}
                            title={"Manage Subjects"}
                            heading={"Manage Subjects"}
                            name={""}
                        />
                    </GetElement>
                }
            />
            <Route
                path="assignment-type"
                element={
                    <GetElement id={"16"} displayList={displayList}>
                        <ManageCommonItemsPage
                            API_URL={"ASSIGNMENT_TYPE_API_URL"}
                            title={"Manage Assignment Type"}
                            heading={"Manage Assignment Type"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="university"
                element={
                    <GetElement id={"17"} displayList={displayList}>
                        <ManageCommonItemsPage
                            API_URL={"UNIVERSITY_API_URL"}
                            title={"Manage University"}
                            heading={"Manage University"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="countries"
                element={
                    <GetElement id={"18"} displayList={displayList}>
                        <ManageCountries
                            title={"Manage Countries"}
                            heading={"Manage Countries"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="about-us"
                element={
                    <GetElement id={"19"} displayList={displayList}>
                        <ManageAboutUs title={"About Us"} heading={"About Us"} name={""} />
                    </GetElement>
                }
            />

            <Route
                path="privacy-policy"
                element={
                    <GetElement id={"20"} displayList={displayList}>
                        <ManagePrivacyPolicy
                            title={"Manage Privacy Policy"}
                            heading={"Manage Privacy Policy"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="terms"
                element={
                    <GetElement id={"21"} displayList={displayList}>
                        <ManageTerms
                            title={"Terms & Conditions"}
                            heading={"Terms & Conditions"}
                            name={""}
                        />
                    </GetElement>
                }
            />

            <Route
                path="academic-tests"
                element={
                    <GetElement id={"23"} displayList={displayList}>
                        <ManageAcademicTests
                            title={"Terms & Conditions"}
                            heading={"Terms & Conditions"}
                            name={""}
                        />
                    </GetElement>
                }
            />
            <Route
                path="academic-test-sets"
                element={
                    <GetElement id={"24"} displayList={displayList}>
                        <ManageAcademicTestSets
                            title={"Academic Test SET"}
                            heading={"Academic Test SET"}
                            name={""}
                        />
                    </GetElement>
                }
            />
        </Routes>
    );
}

const GetElement = ({ displayList, id, children }) => {
    if (displayList?.includes(id) || displayList?.[0] === "0") {
        return (
            <Suspense fallback={<FallbackComponent />}>
                {children}
            </Suspense>
        );

    } else {
        return (<Navigate replace to={"/admin-login"} />)
    }
}

export default SuperAdminPath;
